import { createAsyncThunk,createSlice } from '@reduxjs/toolkit';

import client from '../../utils/axiosInstance';

const initialState = {
  companies: [],
  currentCompany: null,
  // Id pedido por el Navbar antes de que llegue la lista. Sin esto la selección se
  // perdía: el Navbar despacha la compañía guardada mirando activeCompanies, pero este
  // slice la busca en companies, que a veces todavía no cargó.
  idPendiente: null,
};

/** La compañía guardada en el navegador, que es la última que eligió la persona. */
const companiaGuardada = () => {
  try {
    return JSON.parse(localStorage.getItem('userInfo') || '{}').Company ?? null;
  } catch {
    return null;
  }
};

/**
 * Deja en currentCompany la compañía que corresponde: la que se pidió mientras la lista
 * cargaba, si no la guardada en el navegador, y solo como último recurso la primera.
 *
 * Antes caía siempre en companies[0] -People Intelligence-, así que al entrar directo a
 * una URL se consultaba la compañía 1 y las pantallas quedaban vacías o con 404.
 */
const resolverCompaniaActual = (state) => {
  if (state.companies.length === 0) return;

  const buscada = state.idPendiente ?? companiaGuardada();
  const company = state.companies.find((c) => c.id === buscada);

  if (company) {
    state.currentCompany = { ...company };
    state.idPendiente = null;
    return;
  }

  if (!state.currentCompany) {
    state.currentCompany = state.companies[0];
  }
};

export const fetchCompanies = createAsyncThunk(
  'companies/fetchCompanies',
  async ({idUser}) => {
      const { data } = await client.get(`companias/MultiCompani/${idUser}`);
    return data;
  }
);

const companiesSlice = createSlice({
  name: 'companies',
  initialState,
  reducers: {
    companiesAdded(state, action) {
      /*
      state.companies = action.payload
      ...new Set([
        ...state.companies,
        ...action.payload]),
      ];*/
      state.companies = action.payload;
      resolverCompaniaActual(state);
    },
    currentCompanySelected(state, action) {
      const company = state.companies
        .find((company) => company.id === action.payload);

      if (company) {
        state.currentCompany = { ...company };
        state.idPendiente = null;
        return;
      }

      // La lista todavía no llegó: se recuerda el id en vez de borrar la selección.
      // Poner null acá era lo que dejaba la puerta abierta a que después se eligiera
      // companies[0] y la persona terminara viendo otra compañía.
      state.idPendiente = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCompanies.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchCompanies.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.companies = action.payload;
        resolverCompaniaActual(state);
      } )
      .addCase(fetchCompanies.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      }
    );
  },
});

export const { companiesAdded, currentCompanySelected } = companiesSlice.actions;

export const selectAllCompanies = (state) => state.companies.companies;

export const selectCompanyById = (state, companyId) => state.companies.companies.find((company) => company.id === companyId);

export default companiesSlice.reducer;